module.exports = __webpack_public_path__ + "static/media/pac_life.d4edf1dd.jpg";